var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 115,
    viewBox: "0 0 122 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_1009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38281 113.449H121",
    stroke: "#EBF0F6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2641 112.568C80.8895 112.788 70.8619 112.568 63.8096 112.458C56.7572 112.678 46.7297 112.788 38.355 112.568C46.6195 107.832 49.4845 99.1314 49.9253 93.4043H77.5837C78.1347 99.1314 80.9997 107.832 89.2641 112.568Z",
    fill: "url(#paint0_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2369 114H88.3829C89.0441 114 89.7052 113.449 89.7052 112.678C89.7052 112.018 89.1543 111.357 88.3829 111.357H39.2369C38.5757 111.357 37.9146 111.907 37.9146 112.678C37.9146 113.449 38.4655 114 39.2369 114Z",
    fill: "#EBF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.152 20.4941V92.4132C116.152 94.1754 114.719 95.497 113.066 95.497H15.1049C13.452 95.497 12.0195 94.0652 12.0195 92.4132V20.4941C12.0195 18.842 13.452 17.4102 15.1049 17.4102H113.066C114.719 17.4102 116.152 18.7319 116.152 20.4941Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.152 20.4941V82.5009H12.0195V20.4941C12.0195 18.842 13.452 17.4102 15.1049 17.4102H113.066C114.719 17.4102 116.152 18.7319 116.152 20.4941Z",
    fill: "#172D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.074 21.2656H15.4351V78.9771H112.074V21.2656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8098 91.8632C65.2096 91.8632 66.3443 90.729 66.3443 89.33C66.3443 87.931 65.2096 86.7969 63.8098 86.7969C62.4101 86.7969 61.2754 87.931 61.2754 89.33C61.2754 90.729 62.4101 91.8632 63.8098 91.8632Z",
    fill: "#DBDFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8431 70.166H17.6392V72.3687H19.8431V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8431 65.7598H17.6392V67.9625H19.8431V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8431 61.4648H17.6392V63.6676H19.8431V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8431 57.1699H17.6392V59.3726H19.8431V57.1699Z",
    fill: "url(#paint1_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8431 52.7637H17.6392V54.9664H19.8431V52.7637Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8431 48.4688H17.6392V50.6715H19.8431V48.4688Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.361 74.4609H22.1572V76.6637H24.361V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.361 70.166H22.1572V72.3687H24.361V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.361 61.4648H22.1572V63.6676H24.361V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.361 57.1699H22.1572V59.3726H24.361V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.361 52.7637H22.1572V54.9664H24.361V52.7637Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.361 48.4688H22.1572V50.6715H24.361V48.4688Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.361 44.1738H22.1572V46.3765H24.361V44.1738Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.361 39.7676H22.1572V41.9704H24.361V39.7676Z",
    fill: "url(#paint2_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 74.4609H26.6748V76.6637H28.8787V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 70.166H26.6748V72.3687H28.8787V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 65.7598H26.6748V67.9625H28.8787V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 61.4648H26.6748V63.6676H28.8787V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 57.1699H26.6748V59.3726H28.8787V57.1699Z",
    fill: "url(#paint3_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 52.7637H26.6748V54.9664H28.8787V52.7637Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 48.4688H26.6748V50.6715H28.8787V48.4688Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 44.1738H26.6748V46.3765H28.8787V44.1738Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 39.7676H26.6748V41.9704H28.8787V39.7676Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 35.4727H26.6748V37.6754H28.8787V35.4727Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2864 74.4609H31.0825V76.6637H33.2864V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2864 70.166H31.0825V72.3687H33.2864V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2864 65.7598H31.0825V67.9625H33.2864V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2864 61.4648H31.0825V63.6676H33.2864V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2864 57.1699H31.0825V59.3726H33.2864V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2864 52.7637H31.0825V54.9664H33.2864V52.7637Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2864 48.4688H31.0825V50.6715H33.2864V48.4688Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2864 44.1738H31.0825V46.3765H33.2864V44.1738Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8044 74.4609H35.6006V76.6637H37.8044V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8044 70.166H35.6006V72.3687H37.8044V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8044 65.7598H35.6006V67.9625H37.8044V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8044 57.1699H35.6006V59.3726H37.8044V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8044 52.7637H35.6006V54.9664H37.8044V52.7637Z",
    fill: "url(#paint4_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8044 48.4688H35.6006V50.6715H37.8044V48.4688Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3226 74.4609H40.1187V76.6637H42.3226V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3226 70.166H40.1187V72.3687H42.3226V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3226 65.7598H40.1187V67.9625H42.3226V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3226 61.4648H40.1187V63.6676H42.3226V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3226 57.1699H40.1187V59.3726H42.3226V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3226 52.7637H40.1187V54.9664H42.3226V52.7637Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3226 48.4688H40.1187V50.6715H42.3226V48.4688Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3226 44.1738H40.1187V46.3765H42.3226V44.1738Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3226 39.7676H40.1187V41.9704H42.3226V39.7676Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.84 74.4609H44.6362V76.6637H46.84V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.84 70.166H44.6362V72.3687H46.84V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.84 65.7598H44.6362V67.9625H46.84V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.84 57.1699H44.6362V59.3726H46.84V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.84 52.7637H44.6362V54.9664H46.84V52.7637Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3582 74.4609H49.1543V76.6637H51.3582V74.4609Z",
    fill: "url(#paint5_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3582 70.166H49.1543V72.3687H51.3582V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3582 65.7598H49.1543V67.9625H51.3582V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3582 61.4648H49.1543V63.6676H51.3582V61.4648Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3582 57.1699H49.1543V59.3726H51.3582V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3582 48.4688H49.1543V50.6715H51.3582V48.4688Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3582 44.1738H49.1543V46.3765H51.3582V44.1738Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8758 74.4609H53.6719V76.6637H55.8758V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8758 70.166H53.6719V72.3687H55.8758V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8758 65.7598H53.6719V67.9625H55.8758V65.7598Z",
    fill: "url(#paint6_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8758 61.4648H53.6719V63.6676H55.8758V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8758 57.1699H53.6719V59.3726H55.8758V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8758 52.7637H53.6719V54.9664H55.8758V52.7637Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8758 48.4688H53.6719V50.6715H55.8758V48.4688Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8758 39.7676H53.6719V41.9704H55.8758V39.7676Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8758 35.4727H53.6719V37.6754H55.8758V35.4727Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5013 70.166H85.2974V72.3687H87.5013V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5013 61.4648H85.2974V63.6676H87.5013V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5013 57.1699H85.2974V59.3726H87.5013V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5013 52.7637H85.2974V54.9664H87.5013V52.7637Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5013 48.4688H85.2974V50.6715H87.5013V48.4688Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5013 44.1738H85.2974V46.3765H87.5013V44.1738Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0193 74.4609H89.8154V76.6637H92.0193V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0193 70.166H89.8154V72.3687H92.0193V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0193 65.7598H89.8154V67.9625H92.0193V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0193 61.4648H89.8154V63.6676H92.0193V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0193 57.1699H89.8154V59.3726H92.0193V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0193 52.7637H89.8154V54.9664H92.0193V52.7637Z",
    fill: "url(#paint7_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0193 48.4688H89.8154V50.6715H92.0193V48.4688Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5373 74.4609H94.3335V76.6637H96.5373V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5373 70.166H94.3335V72.3687H96.5373V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5373 65.7598H94.3335V67.9625H96.5373V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5373 61.4648H94.3335V63.6676H96.5373V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5373 57.1699H94.3335V59.3726H96.5373V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5373 52.7637H94.3335V54.9664H96.5373V52.7637Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5373 48.4688H94.3335V50.6715H96.5373V48.4688Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5373 44.1738H94.3335V46.3765H96.5373V44.1738Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5373 39.7676H94.3335V41.9704H96.5373V39.7676Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.945 74.4609H98.7412V76.6637H100.945V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.945 70.166H98.7412V72.3687H100.945V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.945 65.7598H98.7412V67.9625H100.945V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.945 61.4648H98.7412V63.6676H100.945V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.945 57.1699H98.7412V59.3726H100.945V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.463 74.4609H103.259V76.6637H105.463V74.4609Z",
    fill: "url(#paint8_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.463 70.166H103.259V72.3687H105.463V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.463 65.7598H103.259V67.9625H105.463V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.463 61.4648H103.259V63.6676H105.463V61.4648Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.463 57.1699H103.259V59.3726H105.463V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.463 52.7637H103.259V54.9664H105.463V52.7637Z",
    fill: "url(#paint9_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.463 48.4688H103.259V50.6715H105.463V48.4688Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.463 44.1738H103.259V46.3765H105.463V44.1738Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 74.4609H107.777V76.6637H109.981V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 70.166H107.777V72.3687H109.981V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 65.7598H107.777V67.9625H109.981V65.7598Z",
    fill: "url(#paint10_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 61.4648H107.777V63.6676H109.981V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 57.1699H107.777V59.3726H109.981V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 52.7637H107.777V54.9664H109.981V52.7637Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 48.4688H107.777V50.6715H109.981V48.4688Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 39.7676H107.777V41.9704H109.981V39.7676Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 35.4727H107.777V37.6754H109.981V35.4727Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3942 74.4609H58.1904V76.6637H60.3942V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3942 70.166H58.1904V72.3687H60.3942V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3942 65.7598H58.1904V67.9625H60.3942V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3942 57.1699H58.1904V59.3726H60.3942V57.1699Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3942 48.4688H58.1904V50.6715H60.3942V48.4688Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3942 44.1738H58.1904V46.3765H60.3942V44.1738Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3942 39.7676H58.1904V41.9704H60.3942V39.7676Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3942 35.4727H58.1904V37.6754H60.3942V35.4727Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9119 70.166H62.708V72.3687H64.9119V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9119 65.7598H62.708V67.9625H64.9119V65.7598Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9119 61.4648H62.708V63.6676H64.9119V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9119 57.1699H62.708V59.3726H64.9119V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9119 52.7637H62.708V54.9664H64.9119V52.7637Z",
    fill: "url(#paint11_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9119 48.4688H62.708V50.6715H64.9119V48.4688Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9119 44.1738H62.708V46.3765H64.9119V44.1738Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4299 74.4609H67.2261V76.6637H69.4299V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4299 65.7598H67.2261V67.9625H69.4299V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4299 61.4648H67.2261V63.6676H69.4299V61.4648Z",
    fill: "url(#paint12_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4299 57.1699H67.2261V59.3726H69.4299V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4299 52.7637H67.2261V54.9664H69.4299V52.7637Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4299 48.4688H67.2261V50.6715H69.4299V48.4688Z",
    fill: "url(#paint13_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9475 74.4609H71.7437V76.6637H73.9475V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9475 61.4648H71.7437V63.6676H73.9475V61.4648Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9475 57.1699H71.7437V59.3726H73.9475V57.1699Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9475 52.7637H71.7437V54.9664H73.9475V52.7637Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4656 74.4609H76.2617V76.6637H78.4656V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4656 70.166H76.2617V72.3687H78.4656V70.166Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4656 65.7598H76.2617V67.9625H78.4656V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4656 61.4648H76.2617V63.6676H78.4656V61.4648Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4656 57.1699H76.2617V59.3726H78.4656V57.1699Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4656 52.7637H76.2617V54.9664H78.4656V52.7637Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4656 48.4688H76.2617V50.6715H78.4656V48.4688Z",
    fill: "url(#paint14_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4656 44.1738H76.2617V46.3765H78.4656V44.1738Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8733 74.4609H80.6694V76.6637H82.8733V74.4609Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8733 65.7598H80.6694V67.9625H82.8733V65.7598Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8733 61.4648H80.6694V63.6676H82.8733V61.4648Z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1021 70.0547H46.62C45.2977 70.0547 44.1958 68.9534 44.1958 67.6317V31.507C44.1958 30.1853 45.2977 29.084 46.62 29.084H82.1021C83.4244 29.084 84.5264 30.1853 84.5264 31.507V67.6317C84.5264 68.9534 83.4244 70.0547 82.1021 70.0547Z",
    fill: "#1C3754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1404 42.8521C66.2705 42.8521 67.9972 41.1263 67.9972 38.9973C67.9972 36.8684 66.2705 35.1426 64.1404 35.1426C62.0104 35.1426 60.2837 36.8684 60.2837 38.9973C60.2837 41.1263 62.0104 42.8521 64.1404 42.8521Z",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9148 49.7894H50.2564C49.9258 49.7894 49.5952 49.459 49.5952 49.1286V46.1549C49.5952 45.8245 49.9258 45.4941 50.2564 45.4941H77.9148C78.2453 45.4941 78.5759 45.8245 78.5759 46.1549V49.1286C78.5759 49.459 78.2453 49.7894 77.9148 49.7894Z",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9148 57.1703H50.2564C49.9258 57.1703 49.5952 56.8399 49.5952 56.5095V53.5358C49.5952 53.2054 49.9258 52.875 50.2564 52.875H77.9148C78.2453 52.875 78.5759 53.2054 78.5759 53.5358V56.5095C78.5759 56.8399 78.2453 57.1703 77.9148 57.1703Z",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0247 59.373H68.3277C67.9971 59.373 67.6665 59.5933 67.6665 60.0338V62.4568C67.6665 62.7872 67.8869 63.1177 68.3277 63.1177H78.0247C78.3553 63.1177 78.6858 62.8974 78.6858 62.4568V60.0338C78.5756 59.7034 78.3553 59.373 78.0247 59.373Z",
    fill: "url(#paint15_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7107 60.8047H70.5316C70.3112 60.8047 70.0908 61.0251 70.0908 61.2455C70.0908 61.4658 70.3112 61.6862 70.5316 61.6862H75.7107C75.9311 61.6862 76.1514 61.4658 76.1514 61.2455C76.1514 60.9149 75.9311 60.8047 75.7107 60.8047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2425 54.7461H52.0193C51.799 54.7461 51.5786 54.9664 51.5786 55.1868C51.5786 55.4072 51.799 55.6276 52.0193 55.6276H65.2425C65.4629 55.6276 65.6833 55.4072 65.6833 55.1868C65.5731 54.8562 65.4629 54.7461 65.2425 54.7461Z",
    fill: "#6A99CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2425 47.1465H52.0193C51.799 47.1465 51.5786 47.3668 51.5786 47.5872C51.5786 47.8076 51.799 48.028 52.0193 48.028H65.2425C65.4629 48.028 65.6833 47.8076 65.6833 47.5872C65.5731 47.3668 65.4629 47.1465 65.2425 47.1465Z",
    fill: "#6A99CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.03 81.1799C104.03 85.2549 102.267 88.8894 99.5126 91.4225C96.9781 93.7354 93.6723 95.1672 90.036 95.1672C87.0608 95.1672 84.3059 94.2861 82.1021 92.7442C78.4657 90.211 76.0415 86.0259 76.0415 81.29C76.0415 73.5804 82.3225 67.3027 90.036 67.3027C97.7495 67.3027 104.03 73.4703 104.03 81.1799Z",
    fill: "#E9F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.843 92.3023C99.7328 91.9719 99.7328 91.6415 99.6226 91.3111C99.6226 91.201 99.5124 91.0908 99.4022 90.8706C98.8513 89.7692 97.9697 88.6678 96.7576 88.007C96.2066 87.6766 95.5455 87.5665 94.7741 87.5665C94.5537 87.5665 94.3334 87.5665 94.2232 87.5665C93.011 87.5665 92.9009 87.3462 92.9009 87.3462V85.3637C93.562 84.8131 94.113 84.2624 94.5538 83.6016C94.9945 82.9407 95.3251 82.2799 95.5455 81.509C96.3168 81.2887 96.8678 80.6279 96.7576 79.8569C96.7576 79.5265 96.5372 79.1961 96.5372 78.8657C96.5372 78.6454 96.5372 78.5353 96.5372 78.315C96.5372 78.2049 96.5372 78.0947 96.5372 77.9846C96.5372 77.8745 96.5372 77.7643 96.5372 77.6542C96.427 77.1035 96.3168 76.4427 95.8761 75.6717C94.8843 73.7994 92.9009 72.5879 90.697 72.5879C90.2562 72.5879 89.8155 72.5879 89.3747 72.698C88.6033 72.9183 87.832 73.2487 87.1708 73.6893C87.0606 73.7994 86.9504 73.9095 86.8402 74.0197C86.8402 74.0197 86.7301 74.0197 86.7301 74.1298C86.0689 74.7906 85.5179 75.5616 85.1874 76.5528C84.8568 77.4339 84.8568 78.4251 84.967 79.4164C84.967 79.4164 84.967 79.4164 84.967 79.5265C84.967 79.5265 84.967 79.5265 84.967 79.6366C84.967 79.8569 85.0772 79.7468 84.967 79.967L84.8568 80.0772C84.7466 80.2975 84.6364 80.738 84.7466 81.1786C85.0772 82.0596 85.6281 81.9495 86.1791 82.3901C86.1791 82.3901 86.0689 82.3901 86.0689 82.5002L85.4077 82.7205C82.6529 83.6015 81.7714 85.9144 82.8733 87.3462C83.3141 87.8969 83.9752 88.3374 85.0772 88.5577C84.7466 88.5577 84.5262 88.778 84.416 88.8881C83.2039 89.8793 82.4325 91.3111 82.2121 92.7429C82.102 93.1834 82.5427 93.5138 82.8733 93.5138H99.0717C99.6226 93.1834 99.9532 92.7429 99.843 92.3023ZM87.1708 84.2624C87.281 84.4826 87.5014 84.7029 87.7218 84.9232C87.832 85.0333 88.0524 85.2536 88.2728 85.3637C88.3829 85.4739 88.4931 85.584 88.6033 85.584C88.6033 85.584 88.6033 85.584 88.7135 85.6941C88.7135 85.6941 88.8237 85.6941 88.8237 85.8043V86.9056C88.8237 86.9056 88.8237 86.9056 88.7135 86.7955C88.6033 86.6854 88.4931 86.5752 88.383 86.5752C88.1626 86.4651 88.0524 86.355 87.832 86.2448C87.7218 86.2448 87.7218 86.1347 87.6116 86.1347C87.0606 85.8043 86.5097 85.4739 86.5097 85.0333C86.6199 84.8131 86.8402 84.5928 87.1708 84.2624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5126 91.3109C96.9782 93.6238 93.6723 95.0556 90.0359 95.0556C87.0608 95.0556 84.306 94.1745 82.1021 92.6326C82.1021 92.5224 82.1021 92.5224 82.1021 92.4123C82.3225 90.9805 83.0939 89.5487 84.306 88.5575C84.5264 88.4474 84.7468 88.2271 84.9671 88.2271C83.9754 88.0068 83.2041 87.5663 82.7633 87.0156H86.0691C86.9506 88.3372 88.4933 89.1082 90.2564 89.1082C91.6889 89.1082 93.0112 88.5575 93.8928 87.5663C94.003 87.5663 94.1132 87.5663 94.2233 87.5663C94.3335 87.5663 94.5539 87.5663 94.7743 87.5663C95.5457 87.5663 96.2068 87.7866 96.7578 88.0068C97.9699 88.5575 98.8515 89.6589 99.4024 90.8704C99.4024 91.0907 99.5126 91.2008 99.5126 91.3109Z",
    fill: "url(#paint16_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9009 85.3652V87.2375L87.5015 87.4578L87.832 86.2463C87.9422 86.2463 87.9422 86.3564 88.0524 86.3564C88.2728 86.4665 88.383 86.5767 88.6034 86.6868C88.7136 86.7969 88.8238 86.7969 88.934 86.9071C88.934 86.9071 88.934 86.9071 89.0442 87.0172V85.8057C89.0442 85.8057 88.934 85.8057 88.934 85.6956C89.8155 86.1361 91.1378 86.4665 92.9009 85.3652Z",
    fill: "url(#paint17_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.427 77.9853C95.3251 78.3157 94.2231 78.536 93.1212 78.4258C91.3581 78.3157 89.595 77.5448 88.2727 76.3333C87.8319 77.6549 86.73 78.6461 85.4077 79.1968C85.1873 79.3069 85.0771 79.3069 84.8567 79.4171C84.8567 79.4171 84.8567 79.4171 84.8567 79.3069C84.7465 78.3157 84.8567 77.4346 85.0771 76.4434C85.4077 75.5623 85.9587 74.6812 86.6198 74.0204C86.6198 74.0204 86.73 74.0204 86.73 73.9102C86.8402 73.8001 86.9504 73.69 87.0606 73.5798C87.7217 73.1393 88.4931 72.8089 89.2644 72.5886C89.7052 72.4785 90.146 72.4785 90.5868 72.4785C92.7906 72.4785 94.7741 73.69 95.7658 75.5623C96.0964 76.3332 96.3168 76.8839 96.427 77.4346C96.427 77.6549 96.427 77.765 96.427 77.9853Z",
    fill: "#1C3754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.595 90.6504C89.1542 91.2011 88.2727 91.3112 87.5013 91.2011C88.2727 90.4301 87.8319 87.897 85.0771 88.2274C81.2203 87.4564 81.6611 83.6016 85.4077 82.3901L86.0688 82.1699L86.179 82.28C86.5096 83.051 86.8402 83.7118 87.2809 84.2625C85.7382 85.5841 87.8319 85.9145 88.9338 86.9057C89.7052 87.4564 90.4765 89.549 89.595 90.6504Z",
    fill: "#1C3754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.03 81.1799C104.03 85.2549 102.267 88.8894 99.5126 91.4225C96.9781 93.7354 93.6723 95.1672 90.036 95.1672C87.0608 95.1672 84.3059 94.2861 82.1021 92.7442C78.4657 90.211 76.0415 86.0259 76.0415 81.29C76.0415 73.5804 82.3225 67.3027 90.036 67.3027C97.7495 67.3027 104.03 73.4703 104.03 81.1799Z",
    stroke: "white",
    strokeWidth: 1.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0248 19.5029C38.0248 24.4591 36.0413 28.9747 32.9559 32.2788C32.7355 32.6092 32.405 32.8294 32.0744 33.1598C28.7686 36.2437 24.3609 38.116 19.5124 38.116C15.6557 38.116 12.0193 36.9045 8.93389 34.8119C8.05234 34.2612 7.28099 33.4903 6.50964 32.8294C3.09366 29.4152 1 24.7895 1 19.6131C1 9.26023 9.26447 1 19.5124 1C29.7603 1 38.0248 9.26023 38.0248 19.5029Z",
    fill: "#E9F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0248 19.5029C38.0248 24.8996 35.7108 29.7456 32.0744 33.0497C28.7686 36.1335 24.3609 38.0059 19.5124 38.0059C15.6557 38.0059 12.0193 36.7944 8.93389 34.7018C4.0854 31.3977 1 25.7807 1 19.5029C1 9.26023 9.26447 1 19.5124 1C29.7603 1 38.0248 9.26023 38.0248 19.5029Z",
    fill: "#E9F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.956 32.2792C32.7356 32.6096 32.4051 32.8299 32.0745 33.1603C28.7687 36.2441 24.361 38.1165 19.5125 38.1165C15.6558 38.1165 12.0194 36.905 8.93402 34.8124C8.05247 34.2617 7.28112 33.4907 6.50977 32.8299C6.95055 32.2792 7.6117 31.9488 9.04421 31.3981L9.59517 31.1779C10.6971 30.7373 12.2398 30.1866 14.2232 29.3055C14.5538 29.1954 14.7742 28.9751 14.9946 28.7549C15.1048 28.6447 15.215 28.5346 15.215 28.3143C15.3252 28.094 15.4354 27.7636 15.4354 27.5434V23.7987C15.3252 23.6886 15.3252 23.6886 15.215 23.5784C14.8844 23.1379 14.664 22.5872 14.664 21.9264L14.3334 21.8163C13.3417 22.0365 13.4519 21.0453 13.2315 19.0628C13.1213 18.1818 13.2315 18.0716 13.6723 17.9615L14.0029 17.5209C13.3417 15.8689 13.0111 14.5473 13.0111 13.4459C13.0111 11.5736 13.7825 10.3621 14.8844 9.81135C14.2232 8.1593 14.2232 7.71875 14.2232 7.71875C14.2232 7.71875 18.08 8.37957 19.5125 8.1593C21.1654 7.82889 23.81 8.26944 24.8018 10.4722C26.4547 11.133 27.0056 12.1243 27.226 13.2256C27.4464 14.9878 26.4547 16.9703 26.2343 17.6311V17.7412C26.4547 17.8513 26.5648 18.0716 26.4547 18.8426C26.2343 20.7149 26.2343 21.8163 25.3527 21.596L24.4712 23.0278C24.4712 23.248 24.4712 23.248 24.361 23.3582C24.361 23.6886 24.361 24.2393 24.361 27.3231C24.361 27.6535 24.4712 28.094 24.6916 28.3143C24.8018 28.4244 24.8018 28.5346 24.912 28.5346C25.1323 28.7549 25.3527 28.9751 25.5731 29.0853C27.777 29.9664 29.4299 30.6272 30.5318 31.0677C31.7439 31.5083 32.4051 31.8387 32.956 32.2792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.956 32.2783C32.7356 32.6087 32.4051 32.829 32.0745 33.1594C28.7687 36.2432 24.361 38.1155 19.5125 38.1155C15.6558 38.1155 12.0194 36.904 8.93402 34.8114C8.05247 34.2608 7.28112 33.4898 6.50977 32.829C6.95055 32.2783 7.6117 31.9479 9.04421 31.3972L9.59517 31.1769C10.6971 30.7364 12.2398 30.1857 14.2232 29.3046C14.5538 29.1945 14.7742 28.9742 14.9946 28.7539C16.0965 30.2958 17.8596 31.2871 19.9533 31.2871C21.9367 31.2871 23.6998 30.2958 24.8018 28.8641C25.0221 29.0843 25.2425 29.3046 25.4629 29.4148C27.6668 30.2958 29.3197 30.9567 30.4216 31.3972C31.7439 31.5073 32.4051 31.8378 32.956 32.2783Z",
    fill: "url(#paint18_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1239 17.6311C26.2341 17.1905 26.0137 16.5297 25.7933 16.1993C25.7933 16.0892 25.6831 16.0892 25.6831 15.979C24.9118 14.4371 23.2589 13.8864 21.7162 13.7763C17.639 13.556 17.3084 14.327 15.9861 13.2256C16.4269 13.7763 16.4269 14.7675 15.7657 15.8689C15.325 16.6398 14.5536 17.0804 13.7823 17.3007C11.909 13.1155 12.9007 10.4722 14.6638 9.59107C14.223 8.1593 14.223 7.71875 14.223 7.71875C14.223 7.71875 18.0798 8.37957 19.5123 8.1593C21.1652 7.82889 23.8098 8.26944 24.8016 10.4722C26.4545 11.133 27.0054 12.1243 27.2258 13.2256C27.336 14.9878 26.3443 16.8601 26.1239 17.6311Z",
    fill: "#1C3754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4352 27.3219V23.5772C15.325 23.4671 15.325 23.4671 15.2148 23.357V23.1367C15.4352 23.4671 15.6555 23.7975 15.9861 24.0178L18.9613 26.1104C19.6225 26.6611 20.6142 26.6611 21.3856 26.1104L24.1404 23.6874C24.2506 23.5772 24.3608 23.4671 24.471 23.4671C24.471 23.7975 24.471 24.3482 24.471 27.432C24.471 27.6523 24.471 27.7624 24.5812 27.9827H15.5453C15.4352 27.7624 15.4352 27.5421 15.4352 27.3219Z",
    fill: "url(#paint19_linear_288_1009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0248 19.5029C38.0248 24.8996 35.7108 29.7456 32.0744 33.0497C28.7686 36.1335 24.3609 38.0059 19.5124 38.0059C15.6557 38.0059 12.0193 36.7944 8.93389 34.7018C4.0854 31.3977 1 25.7807 1 19.5029C1 9.26023 9.26447 1 19.5124 1C29.7603 1 38.0248 9.26023 38.0248 19.5029Z",
    stroke: "white",
    strokeWidth: 1.9345,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_288_1009",
    x1: 63.8034,
    y1: 112.051,
    x2: 63.8034,
    y2: 94.8716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9913,
    stopColor: "#D8E0EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_288_1009",
    x1: 17.6081,
    y1: 58.238,
    x2: 19.8196,
    y2: 58.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_288_1009",
    x1: 22.1163,
    y1: 40.894,
    x2: 24.3279,
    y2: 40.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_288_1009",
    x1: 26.6242,
    y1: 58.238,
    x2: 28.8358,
    y2: 58.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_288_1009",
    x1: 35.6407,
    y1: 53.9015,
    x2: 37.8523,
    y2: 53.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_288_1009",
    x1: 49.1652,
    y1: 75.581,
    x2: 51.3768,
    y2: 75.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_288_1009",
    x1: 53.6731,
    y1: 66.9089,
    x2: 55.8846,
    y2: 66.9089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_288_1009",
    x1: 89.7741,
    y1: 53.9015,
    x2: 91.9857,
    y2: 53.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_288_1009",
    x1: 103.299,
    y1: 75.581,
    x2: 105.51,
    y2: 75.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_288_1009",
    x1: 103.299,
    y1: 53.9015,
    x2: 105.51,
    y2: 53.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_288_1009",
    x1: 107.807,
    y1: 66.9089,
    x2: 110.019,
    y2: 66.9089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_288_1009",
    x1: 62.6897,
    y1: 53.9015,
    x2: 64.9013,
    y2: 53.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_288_1009",
    x1: 67.198,
    y1: 62.5735,
    x2: 69.4095,
    y2: 62.5735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_288_1009",
    x1: 67.198,
    y1: 49.5661,
    x2: 69.4095,
    y2: 49.5661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_288_1009",
    x1: 76.2142,
    y1: 49.5661,
    x2: 78.4258,
    y2: 49.5661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_288_1009",
    x1: 67.7028,
    y1: 61.2069,
    x2: 78.6,
    y2: 61.2069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_288_1009",
    x1: 82.1363,
    y1: 91.0838,
    x2: 99.5602,
    y2: 91.0838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_288_1009",
    x1: 90.2161,
    y1: 87.2152,
    x2: 90.2161,
    y2: 86.3743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9913,
    stopColor: "#E6EDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_288_1009",
    x1: 6.49291,
    y1: 33.2652,
    x2: 32.906,
    y2: 33.2652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_288_1009",
    x1: 19.8832,
    y1: 27.9044,
    x2: 19.8832,
    y2: 25.2929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9913,
    stopColor: "#E6EDF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_1009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 115,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCall);
export default __webpack_public_path__ + "static/media/new-call.c97fa86643586e45874dc8bcda774d6e.svg";
export { ForwardRef as ReactComponent };